import colors from '@magoosh/lib/styles/colors.module.scss';

export default (examName: string, sections: string) => {
  if (examName === 'GMAT') {
    const quantTypes = [
      {
        name: 'Pure Contexts',
        data: [
          { color: colors.gray85, label: 'Correct', value: 100 },
          { color: colors.grayLightest, label: 'Incorrect', value: 0 }
        ]
      },
      {
        name: 'Real Contexts',
        data: [
          { color: colors.gray85, label: 'Correct', value: 100 },
          { color: colors.grayLightest, label: 'Incorrect', value: 0 }
        ]
      }
    ];

    const verbalTypes = [
      {
        name: 'Critical Reasoning',
        data: [
          { color: colors.gray85, label: 'Correct', value: 100 },
          { color: colors.grayLightest, label: 'Incorrect', value: 0 }
        ]
      },
      {
        name: 'Reading Comprehen...',
        data: [
          { color: colors.gray85, label: 'Correct', value: 100 },
          { color: colors.grayLightest, label: 'Incorrect', value: 0 }
        ]
      }
    ];

    const dataInsightsTypes = [
      {
        name: 'Data Sufficiency',
        data: [
          { color: colors.gray85, label: 'Correct', value: 100 },
          { color: colors.grayLightest, label: 'Incorrect', value: 0 }
        ]
      },
      {
        name: 'Integrated Reasoning',
        data: [
          { color: colors.gray85, label: 'Correct', value: 100 },
          { color: colors.grayLightest, label: 'Incorrect', value: 0 }
        ]
      }
    ];

    if (!sections || sections === 'all') {
      return [
        { name: 'Quantitative Reasoning', data: quantTypes },
        { name: 'Verbal Reasoning', data: verbalTypes },
        { name: 'Data Insights', data: dataInsightsTypes }
      ];
    }

    let result = [];

    if (sections.indexOf('quantitative_reasoning') !== -1){
      result.push({ name: 'Quantitative Reasoning', data: quantTypes });
    }
    if (sections.indexOf('verbal_reasoning') !== -1) {
      result.push({ name: 'Verbal Reasoning', data: verbalTypes });
    }
    if (sections.indexOf('data_insights') !== -1) {
      result.push({ name: 'Data Insights', data: dataInsightsTypes });
    }

    return result;
  } else if (examName === 'GRE') {
    const mathTypes = [
      {
        name: 'Data Interpretation',
        data: [
          { color: colors.gray85, label: 'Correct', value: 100 },
          { color: colors.grayLighest, label: 'Incorrect', value: 0 }
        ]
      },
      {
        name: 'Multiple Answer',
        data: [
          { color: colors.gray85, label: 'Correct', value: 100 },
          { color: colors.grayLighest, label: 'Incorrect', value: 0 }
        ]
      },
      {
        name: 'Multiple Choice',
        data: [
          { color: colors.gray85, label: 'Correct', value: 100 },
          { color: colors.grayLighest, label: 'Incorrect', value: 0 }
        ]
      },
      {
        name: 'Numeric Entry',
        data: [
          { color: colors.gray85, label: 'Correct', value: 100 },
          { color: colors.grayLighest, label: 'Incorrect', value: 0 }
        ]
      },
      {
        name: 'Quantitative Comp...',
        data: [
          { color: colors.gray85, label: 'Correct', value: 100 },
          { color: colors.grayLighest, label: 'Incorrect', value: 0 }
        ]
      }
    ];

    const verbalTypes = [
      {
        name: 'Reading Comprehen...',
        data: [
          { color: colors.gray85, label: 'Correct', value: 100 },
          { color: colors.grayLighest, label: 'Incorrect', value: 0 }
        ]
      },
      {
        name: 'Sentence Equivalence',
        data: [
          { color: colors.gray85, label: 'Correct', value: 100 },
          { color: colors.grayLighest, label: 'Incorrect', value: 0 }
        ]
      },
      {
        name: 'Text Completion',
        data: [
          { color: colors.gray85, label: 'Correct', value: 100 },
          { color: colors.grayLighest, label: 'Incorrect', value: 0 }
        ]
      }
    ];

    if (!sections || sections === 'all') {
      return [
        { name: 'Math', data: mathTypes },
        { name: 'Verbal', data: verbalTypes }
      ];
    }

    let result = [];

    if (sections.indexOf('math') !== -1){
      result.push({ name: 'Math', data: mathTypes });
    }
    if (sections.indexOf('verbal') !== -1) {
      result.push({ name: 'Verbal', data: verbalTypes });
    }

    return result;
  } else {
    return [];
  }
};
